export default __webpack_public_path__ + "static/media/ErrorImage.e66fe87a.jpg";